function toggleFacets() {
    el = document.getElementById('clerk-facets-container');
    if (el) { el.classList.toggle('active') };
}